import { render } from "./EventDetail.vue?vue&type=template&id=3b5dd650&scoped=true"
import script from "./EventDetail.vue?vue&type=script&lang=js"
export * from "./EventDetail.vue?vue&type=script&lang=js"

import "./EventDetail.vue?vue&type=style&index=0&id=3b5dd650&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_seilatv/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5dd650"]])

export default __exports__